import {Text, View} from 'react-native';
import {Typography} from 'src/styles';
import React from 'react';
import {useStyle} from 'src/providers/style';
import {useTranslations} from 'src/providers/translation';
import InformationTooltip from 'src/modules/programs/components/information-tooltip';

const StatusLegend = () => {
  const styles = useStyle();
  const translations = useTranslations();

  return (
    <View
      style={[
        styles.row,
        styles.alignCenter,
        styles.justifyCenter,
        styles.marginLTop,
      ]}>
      <View style={[styles.row, styles.alignCenter, styles.marginRight]}>
        <View
          style={[styles.dotL, styles.backgroundColorTeal, styles.marginLRight]}
        />
        <Text style={[Typography.P3]}>{translations('not_started')}</Text>
      </View>
      <View style={[styles.row, styles.alignCenter, styles.marginRight]}>
        <View
          style={[styles.dotL, styles.backgroundColorLime, styles.marginLRight]}
        />
        <Text style={[Typography.P3]}>{translations('in_progress')}</Text>
      </View>
      <View style={[styles.row, styles.alignCenter, styles.marginRight]}>
        <View
          style={[styles.dotL, styles.backgroundColorRuby, styles.marginLRight]}
        />
        <Text style={[Typography.P3]}>{translations('missing_values')}</Text>
      </View>
      <View style={[styles.row, styles.alignCenter, styles.marginRight]}>
        <View
          style={[
            styles.dotL,
            styles.backgroundColorArctic,
            styles.marginLRight,
          ]}
        />
        <Text style={[Typography.P3]}>{translations('completed')}</Text>
      </View>
      <View style={[styles.row, styles.alignCenter, styles.marginRight]}>
        <View
          style={[
            styles.dotL,
            styles.backgroundColorOrange,
            styles.marginLRight,
          ]}
        />
        <Text style={[Typography.P3]}>{'Event'}</Text>
      </View>
      <View style={[styles.row, styles.alignSelfCenter, styles.marginRight]}>
        <InformationTooltip
          value={
            'Completed appointments with a solidified border indicate that a change has been made to the scheduled time.'
          }
        />
      </View>
    </View>
  );
};

export default StatusLegend;
